import { Component, Input, QueryList, ViewChildren } from '@angular/core';
import { CmpsAccordionItemComponent } from '@cmps/ng-uikit';

import { CaResult } from '../core';

@Component({
    selector: 'cmps-ca-evaluation',
    templateUrl: './ca-evaluation.component.html',
    host: {
        class: 'cmps-ca-evaluation',
    },
})
export class CaEvaluationComponent {
    @ViewChildren(CmpsAccordionItemComponent)
    private readonly _items: QueryList<CmpsAccordionItemComponent>;

    @Input() get caResult(): CaResult {
        return this._caResult;
    }

    set caResult(value: CaResult) {
        this._caResult = value;
    }

    @Input() showReasoning: boolean;

    @Input() get collapsed(): boolean {
        return this._collapsed;
    }

    set collapsed(value: boolean) {
        const manual = this._collapsed === value;
        this._collapsed = value;
        if (manual) {
            // TODO fix CmpsAccordionItemComponent
            this._items?.forEach((e) => (value ? e.close() : e.open()));
        }
    }

    /** @private */ _caResult: CaResult;
    /** @private */ _collapsed: boolean;
}
